import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { permissionGuard, adminGuard } from './core/guards/permission.guard';
import { ShellComponent } from './shared/components/shell/shell.component';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

  // Öffentliche Routen (kein Header/Footer)
  {
    path: 'login',
    loadComponent: () => import('./modules/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'pwa',
    loadComponent: () => import('./modules/pwa/pwa.component').then(m => m.PwaComponent),
  },

  // Geschützte Routen — alle mit Shell (Header + Footer)
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./modules/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'grabpflege',
        loadComponent: () => import('./modules/grabpflege/grabpflege.component').then(m => m.GrabpflegeComponent),
        canActivate: [permissionGuard],
        data: { module: 'grabpflege' },
      },
      {
        path: 'kontakte',
        loadComponent: () => import('./modules/kontakte/kontakte.component').then(m => m.KontakteComponent),
        canActivate: [permissionGuard],
        data: { module: 'kontakte' },
      },
      {
        path: 'floristik/hochzeit',
        loadComponent: () => import('./modules/floristik/floristik.component').then(m => m.FloristikComponent),
        canActivate: [permissionGuard],
        data: { type: 'WEDDING', module: 'floristik' },
      },
      {
        path: 'floristik/trauer',
        loadComponent: () => import('./modules/floristik/floristik.component').then(m => m.FloristikComponent),
        canActivate: [permissionGuard],
        data: { type: 'FUNERAL', module: 'floristik' },
      },
      {
        path: 'aufzucht',
        loadComponent: () => import('./modules/aufzucht/aufzucht.component').then(m => m.AufzuchtComponent),
        canActivate: [permissionGuard],
        data: { module: 'aufzucht' },
      },
      {
        path: 'gartenpflege',
        loadComponent: () => import('./modules/gartenpflege/gartenpflege.component').then(m => m.GartenpflegeComponent),
        canActivate: [permissionGuard],
        data: { module: 'gartenpflege' },
      },
      {
        path: 'lager',
        loadComponent: () => import('./modules/lager/lager.component').then(m => m.LagerComponent),
        canActivate: [permissionGuard],
        data: { module: 'lager' },
      },
      {
        path: 'kalender',
        loadComponent: () => import('./modules/kalender/kalender.component').then(m => m.KalenderComponent),
      },
      {
        path: 'notizen',
        loadComponent: () => import('./modules/notizen/notizen.component').then(m => m.NotizenComponent),
        canActivate: [permissionGuard],
        data: { module: 'notizen' },
      },
      {
        path: 'auftragseingang',
        loadComponent: () => import('./modules/auftragseingang/auftragseingang.component').then(m => m.AuftragseingangComponent),
        canActivate: [permissionGuard],
        data: { module: 'auftragseingang' },
      },
      {
        path: 'einstellungen',
        loadComponent: () => import('./modules/einstellungen/einstellungen.component').then(m => m.EinstellungenComponent),
      },
      {
        path: 'hilfe',
        loadComponent: () => import('./modules/hilfe/hilfe.component').then(m => m.HilfeComponent),
      },
      {
        path: 'profil',
        loadComponent: () => import('./modules/profil/profil.component').then(m => m.ProfilComponent),
      },
      {
        path: 'einstellungen/benachrichtigungen',
        loadComponent: () => import('./modules/benachrichtigungen/benachrichtigungen.component').then(m => m.BenachrichtigungenComponent),
      },
      {
        path: 'einstellungen/benutzer',
        loadComponent: () => import('./modules/benutzer/benutzer.component').then(m => m.BenutzerComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'einstellungen/rechte',
        loadComponent: () => import('./modules/rechte/rechte.component').then(m => m.RechteComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'teams',
        loadComponent: () => import('./modules/teams/teams.component').then(m => m.TeamsComponent),
      },
      {
        path: 'einstellungen/navigation',
        loadComponent: () => import('./modules/meine-navigation/meine-navigation.component').then(m => m.MeineNavigationComponent),
      },
      {
        path: 'einstellungen/papierkorb',
        loadComponent: () => import('./modules/papierkorb/papierkorb.component').then(m => m.PapierkorbComponent),
      },
      {
        path: 'einstellungen/kalender',
        loadComponent: () => import('./modules/kalender-verwaltung/kalender-verwaltung.component').then(m => m.KalenderVerwaltungComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'einstellungen/kontakt-rollen',
        loadComponent: () => import('./modules/kontakt-rollen/kontakt-rollen.component').then(m => m.KontaktRollenComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'einstellungen/friedhoefe',
        loadComponent: () => import('./modules/friedhoefe/friedhoefe.component').then(m => m.FriedhoefeComponent),
        canActivate: [adminGuard],
      },
      {
        path: 'einstellungen/pflegekategorien',
        loadComponent: () => import('./modules/pflegekategorien/pflegekategorien.component').then(m => m.PflegekategorienComponent),
        canActivate: [adminGuard],
      },
    ],
  },

  { path: '**', redirectTo: 'dashboard' },
];
